<template>    
<div class="card border-0 mt-xl-5">
  <div class="card-body">

    <div class="row">
      <div class="col-12">

        <div v-if="loadingContact == 0" class="row">
          <div class="col-12 d-flex justify-content-center align-items-center">
            <scaling-squares-spinner :animation-duration="2000" :size="45" color="#0E1698" style=""/>
            <span class="ml-3 h6" style="color:#0E1698">Loading Contact...</span>
          </div>
        </div>

        <div v-if="loadingContact == 1" class="row">
          <div class="col-6 mb-2">
            <div class="form-group">
              <label for="exampleInputEmail1" class="small mb-0">First Name<i class="fa fa-asterisk text-danger ml-2" aria-hidden="true"></i></label>
              <input type="text" class="form-control" placeholder="First Name" aria-describedby="emailHelp" v-model="f_name">
            </div>
          </div>
          <div class="col-6 mb-2">
            <div class="form-group">
              <label for="exampleInputEmail1" class="small mb-0">Last Name<i class="fa fa-asterisk text-danger ml-2" aria-hidden="true"></i></label>
              <input type="text" class="form-control" placeholder="Last Name" aria-describedby="emailHelp" v-model="l_name">
            </div>
          </div>
          <div class="col-12 mb-2">
            <div class="form-group">
              <label for="exampleInputEmail1" class="small mb-0">Primary Email<i class="fa fa-asterisk text-danger ml-2" aria-hidden="true"></i></label>
              <input type="email" class="form-control" placeholder="Email Address" aria-describedby="emailHelp" v-model="pri_email">
            </div>
          </div>
          <div class="col-12 mb-4">
            <div class="form-group">
              <label for="exampleInputEmail1" class="small mb-0">Primary Phone</label>
              <VuePhoneNumberInput v-model="pri_phone"
                default-country-code="US"
                no-country-selector
                no-validator-state
              />
            </div>
          </div>

          <div class="col-12">
            <button @click="cancelEdit" class="btn btn-primary">Close</button>
            <button @click="saveContact" class="btn btn-success">Save</button>
          </div>
        </div>

      </div>

    </div>

  </div>
</div>
</template>

<script>
import { ScalingSquaresSpinner } from 'epic-spinners'  
import {store} from '../../../stores/settings-user-main-store.js'
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';


export default {
  store,
  props: ['prop1', 'prop2', 'prop3'],
  data: function () {
    return { 
      contactDetails: [],
      loadingContact: 0,
      f_name: '',
      l_name: '',
      pri_email: '',
      pri_phone: null,
    }
  },
  computed: {

  },
  watch: {
    prop1() { this.getContactDetails(); },
    
  },
  mounted() {
    this.getContactDetails();
  },
  methods: {
    getContactDetails(){
      var _this = this;
      _this.loadingContact = 0
      axios.get('/utility/user/contact/getspecificcontact/' + _this.prop1)
        .then(function (response) {
          var a = response.data.data;
          _this.contactDetails = a;
          _this.f_name = _this.contactDetails.f_name;
          _this.l_name = _this.contactDetails.l_name;
          _this.pri_email = _this.contactDetails.pri_email;
          _this.pri_phone = _this.contactDetails.pri_phone;
          _this.loadingContact = 1;
        });
    },
    cancelEdit() {
      var _this = this;
      _this.$emit('onSecondary', [ 'contact-edit', _this.contactDetails.id ])
    },
    saveContact() {
      var _this = this;
      _this.$toastr.warning('Validating contact information.', 'Please wait!')
      //validate with js
      var valErrors = [];
      //validate first name
      if(_this.f_name == '' || _this.f_name == null) { valErrors.push("A first name is required!") }
      //validate last name
      if(_this.l_name == '' || _this.l_name == null) { valErrors.push("A last name is required!") }
      if(_this.l_name.length <= 2 ) { valErrors.push("A last name requires more than two letters!") }
      //validate email
      var mailformat = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;
      if(_this.pri_email == '' || _this.pri_email == null) { 
        valErrors.push("The primary email address is required!") 
      } else if (!_this.pri_email.match(mailformat)) {
        valErrors.push("The primary email address you entered is not valid!") 
      }
      var phoneFormat = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
      if(_this.pri_phone != '' && _this.pri_phone != null) {
        if(!_this.pri_phone.match(phoneFormat)) { valErrors.push("The primary phone number you entered is invalid!") }  
      }

      if(valErrors.length > 0) {
        _this.$toastr.remove();
        _this.errorDisplay(valErrors);
        return false;
      } 

      _this.$toastr.remove()

      _this.$toastr.warning('Saving new contact information.', 'Please wait!')
      axios.post('/utility/all/contact/updatecontact', {
        contact_id: _this.contactDetails.id,
        f_name: _this.f_name,
        l_name: _this.l_name,
        pri_email: _this.pri_email,
        pri_phone: _this.pri_phone,

      })
        .then(function (response) {
          var msg = response.data.msg;
          var a = response.data.con;
          _this.$toastr.remove()
          _this.$toastr.success(msg, 'Success!', {timeOut: 5000});
          _this.$emit('onSComplete', [ 'contact-edit', _this.contactDetails.id, ])
        })
        .catch(function (error) {
          var errors = error.response.data.errors;
          _this.errorDisplay(errors);
        })

    },
    errorDisplay(valErrors) {
      var _this = this;
      var errors = valErrors;
      var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
      $.each(errors, function(key, value){ errorsHTML += '<li>' + value + '</li>' });
      errorsHTML += '</ul></div>';
      _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
    },   
  },    
  components:{
    ScalingSquaresSpinner,
    VuePhoneNumberInput,
  },
  filters: {

  }
}
</script>
